module.exports = __webpack_public_path__ + "static/media/012-line-pink.c543f650.svg";